import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    // Auth.js v5 environment variables
    AUTH_URL: z.string().url().optional(),
    AUTH_SECRET: z.string().min(1).optional(),
    FEXRAPI_URL: z.string().url().optional(),
    FEXRAPI_JWT_SECRET: z.string().min(32).optional(),
    GOOGLE_CLIENT_ID: z.string().min(1).optional(),
    GOOGLE_CLIENT_SECRET: z.string().min(1).optional(),
    DATABASE_URL: z.string().min(1).optional(),
    RESEND_API_KEY: z.string().min(1).optional(),
    DEFAULT_FEXR_VAULT_ID: z.string().min(1).optional(),
    // Old name of DEFAULT_FEXR_VAULT_ID, still read as a fallback.
    DEFAULT_FEXR_CLUB_ID: z.string().min(1).optional(),
    NODE_ENV: z.string().min(1),

    SUPABASE_URL: z.string().min(1).optional(),
    SUPABASE_ANON_KEY: z.string().min(1).optional(),
    MORALIS_API_KEY: z.string().min(1).optional(),
    EMBEDDED_WALLET_MASTER_KEY: z.string().length(64).optional(),
    // Search console ownership tokens (the content= value of each meta tag).
    GOOGLE_SITE_VERIFICATION: z.string().min(1).optional(),
    BING_SITE_VERIFICATION: z.string().min(1).optional(),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.string().min(1).optional(),
    NEXT_PUBLIC_API_SERVER_URL: z.string().url().optional(),

    NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID: z.string().min(1).optional(),
    NEXT_PUBLIC_IOS_APP_URL: z.string().url().optional(),
    NEXT_PUBLIC_ANDROID_APP_URL: z.string().url().optional(),
    NEXT_PUBLIC_WAITLIST_API_BASE: z.string().url().optional(),
    NEXT_PUBLIC_WEB_PUSH_VAPID_PUBLIC_KEY: z.string().min(1).optional(),
  },
  runtimeEnv: {
    NEXTAUTH_URL: process.env.NEXTAUTH_URL,
    NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
    FEXRAPI_URL: process.env.FEXRAPI_URL,
    FEXRAPI_JWT_SECRET: process.env.FEXRAPI_JWT_SECRET,
    GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
    GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
    DATABASE_URL: process.env.DATABASE_URL,
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_API_SERVER_URL: process.env.NEXT_PUBLIC_API_SERVER_URL,
    DEFAULT_FEXR_VAULT_ID: process.env.DEFAULT_FEXR_VAULT_ID,
    DEFAULT_FEXR_CLUB_ID: process.env.DEFAULT_FEXR_CLUB_ID,
    NODE_ENV: process.env.NODE_ENV,

    SUPABASE_URL: process.env.SUPABASE_URL,
    SUPABASE_ANON_KEY: process.env.SUPABASE_ANON_KEY,
    MORALIS_API_KEY: process.env.MORALIS_API_KEY,
    EMBEDDED_WALLET_MASTER_KEY: process.env.EMBEDDED_WALLET_MASTER_KEY,
    GOOGLE_SITE_VERIFICATION: process.env.GOOGLE_SITE_VERIFICATION,
    BING_SITE_VERIFICATION: process.env.BING_SITE_VERIFICATION,

    // Wallet Connect
    NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID:
      process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
    NEXT_PUBLIC_IOS_APP_URL: process.env.NEXT_PUBLIC_IOS_APP_URL,
    NEXT_PUBLIC_ANDROID_APP_URL: process.env.NEXT_PUBLIC_ANDROID_APP_URL,
    NEXT_PUBLIC_WAITLIST_API_BASE: process.env.NEXT_PUBLIC_WAITLIST_API_BASE,
    NEXT_PUBLIC_WEB_PUSH_VAPID_PUBLIC_KEY:
      process.env.NEXT_PUBLIC_WEB_PUSH_VAPID_PUBLIC_KEY,
  },
});
